export const emptyState = {
  title: 'Hi, %{name}!',
  text: 'Sit tight, we’re retrieving your energy usage information. The page will auto-refresh soon.',
  notification: 'Your dashboard is now ready!',
};
